import { Typography } from "@material-ui/core";
import { useStyles } from "../Subdivision/styles";

function Subdivision({title}) {
  const classes = useStyles();
  return(
    <div className={classes.container}>
      <Typography className={classes.title}>
        {title}
      </Typography>
    </div>
  );
}

export default Subdivision;